/*
 * The browser applies `:hover` only when the pointer moves. A drilldown view can move a card
 * to a position below a pointer that does not move. The browser sends no event for this, and
 * the card stays in the usual state. The user must move the pointer to get the hover state.
 *
 * This module sets the attribute `data-pointer-within` on the card below the pointer. The
 * card CSS shows the hover state for that attribute (see choice-card-chrome). The next
 * movement of the pointer removes the attribute, because `:hover` is again correct.
 */

const CARD = "[data-choice-card]"
const FLAG = "data-pointer-within"

let pointerPosition: { x: number; y: number } | null = null

if (typeof document !== "undefined") {
  document.addEventListener(
    "pointermove",
    (event: PointerEvent) => {
      // Touch leaves no pointer on the screen. A tap must not put a card in the hover state.
      if (event.pointerType === "touch") return
      pointerPosition = { x: event.clientX, y: event.clientY }
    },
    { capture: true, passive: true },
  )
}

function removeFlags() {
  document.querySelectorAll(`[${FLAG}]`).forEach((card) => card.removeAttribute(FLAG))
}

/** Puts the card below the pointer into the hover state. Call this after content moves. */
export function setHoverBelowPointer() {
  removeFlags()
  if (!pointerPosition) return
  const card = document.elementFromPoint(pointerPosition.x, pointerPosition.y)?.closest(CARD)
  if (!card) return
  card.setAttribute(FLAG, "")
  document.addEventListener("pointermove", removeFlags, { capture: true, once: true })
}
